import React from 'react';
import '../grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const PastcontExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Past Continuous Tense</h2>

      <p><strong>Form:</strong> was/were + verb + -ing</p>

      <div className="example-block">
        <h3><FaLightbulb /> Usage</h3>
        <ul>
          <li>
            <strong>To describe an action that was in progress at a specific time in the past.</strong><br />
            Example: "At 8 p.m., I <strong>was watching</strong> TV."
          </li>
          <li>
            <strong>To describe two actions happening at the same time in the past.</strong><br />
            Example: "While she <strong>was cooking</strong>, he <strong>was setting</strong> the table."
          </li>
          <li>
            <strong>To describe a longer action interrupted by a shorter action.</strong><br />
            Example: "I <strong>was reading</strong> when the phone rang."
          </li>
          <li>
            <strong>To set the scene in a story or describe background actions.</strong><br />
            Example: "The sun was shining, and birds were singing."
          </li>
        </ul>
      </div>

      <div className="example-block">
        <h3><FaLightbulb /> Examples</h3>
        <ul>
          <li>They <strong>were playing</strong> football when it started to rain.</li>
          <li>We <strong>were walking</strong> home at 7 o'clock yesterday.</li>
        </ul>
      </div>
    </div>
  );
};

export default PastcontExplanation;
